export const chipShape = {
  height: '30px',
  fontSize: '12.5px',
  fontWeight: 550,
} as const;
